import { Box } from "@mui/material";
import { useResource } from "Translations/Resources";
import NotificationsIcon from "@mui/icons-material/Notifications";
import { Resources } from "Translations/Resources";

const RESOURCES = Resources.UserMenu.Notifications;

export const NoNotifications = () => {
  const { t } = useResource();

  return (
    <Box
      p={3}
      minHeight={100}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <Box textAlign="center">
        <NotificationsIcon sx={{ fontSize: 48, color: "grey.400", mb: 1 }} />
        <Box color="text.secondary" fontSize={14}>
          {t(RESOURCES.NoNewNotifications)}
        </Box>
      </Box>
    </Box>
  );
};
